(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
 class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.getElementById('shopify-section-header');
    this.logo = this.header.querySelector('.header__logo');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();

    this.updateLogoDisplayHome();
    this.updateLogoDisplay();
    this.handleScroll();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  updateLogoDisplayHome() {    
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const desktopLogo = document.getElementById('desktopLogo');
    const mobileLogo = document.getElementById('mobileLogo');
    const isMobile = document.getElementById('isMobile');

    if(isMobile){
      if (windowWidth >= 990) {
          desktopLogo.style.display = 'flex';
          mobileLogo.style.display = 'none';
        } else {
          desktopLogo.style.display = 'none';
          mobileLogo.style.display = 'flex';
      }
    }
  }

  updateLogoDisplay() {    
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const desktopLogo = document.getElementById('desktopLogoHeader');
    const mobileLogo = document.getElementById('mobileLogoHeader');
    const isNotHome = document.getElementById('desktop-logo-header');

    if(isNotHome){
      if (windowWidth >= 990) {
          desktopLogo.style.display = 'flex';
          mobileLogo.style.display = 'none';
        } else {
          desktopLogo.style.display = 'none';
          mobileLogo.style.display = 'flex';
      }
    }
  }

  handleScroll() {
      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const header = document.getElementById("header_sticky-custom");
      const isMobile = document.getElementById("isMobile");
      const isDesktop = document.getElementById("isDesktop");

      if (header && isMobile && isDesktop) {
      
          if (windowWidth >= 990) {
              let sticky = header.offsetTop;

              if (window.pageYOffset > sticky) {
                  isMobile.style.display = "flex";
                  isDesktop.style.display = "none";
                  header.classList.add("sticky");
              } else {
                  isMobile.style.display = "none";
                  isDesktop.style.display = "flex";
                  header.classList.remove("sticky");
              }
          } else {
              isMobile.style.display = "flex";
              isDesktop.style.display = "none";
          }
      }
  }


  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }

    if (scrollTop > this.headerBounds.bottom) {
      this.logo.classList.add('logo-hidden');
    } else {
      this.logo.classList.remove('logo-hidden');
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rejuvibrush-oil-selector"] && !Shopify.designMode) return;
  try {
    
  class RejuviOilSelector extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.form = document.querySelector('form[action*="/cart/add"]');
      this.variantInput = this.form && this.form.querySelector('[name="id"]');

      this.cards.forEach((card) => {
        card.addEventListener('click', this.onCardClick.bind(this));
        card.addEventListener('keydown', this.onCardKeydown.bind(this));
      });
    }

    onCardClick(event) {
      this.selectCard(event.currentTarget);
    }

    onCardKeydown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.selectCard(event.currentTarget);
      }
    }

    selectCard(card) {
      // Swap active highlight
      this.cards.forEach((c) => {
        c.classList.remove('is-active');
        c.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('is-active');
      card.setAttribute('aria-pressed', 'true');

      // Push new variant ID into the product form hidden input
      const { variantId, option1, option2, price, compareAtPrice, priceCents, compareAtPriceCents } = card.dataset;

      if (variantId && this.variantInput) {
        this.variantInput.value = variantId;
      }

      // Sync Dawn's native variant-selects/variant-radios so it updates
      // price, availability, and Add to Cart state through its own machinery
      if (option1) {
        this.syncVariantSelects(option1, option2);
      } else if (variantId && this.variantInput) {
        // Fallback: no option data, just fire change on the hidden input directly
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Direct price update as a safety net for themes that don't react to the above
      if (price) {
        this.updatePrice(
          price,
          compareAtPrice,
          parseInt(priceCents || '0', 10),
          parseInt(compareAtPriceCents || '0', 10)
        );
      }

      // Notify the Value Stack of the newly selected oil name
      const nameEl = card.querySelector('.rejuvi-oil-selector__card-name');
      if (nameEl) {
        document.dispatchEvent(new CustomEvent('rejuvi:oil-selected', {
          detail: { name: nameEl.textContent.trim() }
        }));
      }
    }

    syncVariantSelects(option1, option2) {
      const picker = document.querySelector('variant-selects, variant-radios');
      if (!picker) return;

      let triggered = false;

      // Select-based picker (Dawn dropdown mode)
      picker.querySelectorAll('select').forEach((select, i) => {
        const target = i === 0 ? option1 : option2;
        if (target && select.value !== target) {
          select.value = target;
          triggered = true;
        }
      });

      // Radio-based picker (Dawn pills mode)
      if (!triggered) {
        picker.querySelectorAll('input[type="radio"]').forEach((radio) => {
          if (radio.value === option1) {
            radio.checked = true;
            triggered = true;
          }
        });
      }

      if (triggered) {
        // Bubbles up to variant-selects/variant-radios, triggering Dawn's
        // full onVariantChange: price, availability, media, URL update
        picker.querySelector('select, input[type="radio"]')
          .dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    updatePrice(price, compareAtPrice, priceCents, compareAtPriceCents) {
      const isOnSale = compareAtPriceCents > 0 && compareAtPriceCents > priceCents;

      // ── Dawn price structure ──────────────────────────────────────────────
      document.querySelectorAll('.price:not(.price--sold-out)').forEach((priceEl) => {
        if (isOnSale) {
          priceEl.classList.add('price--on-sale');

          // Current (sale) price
          const salePriceEl = priceEl.querySelector('.price__sale .price-item--sale');
          if (salePriceEl) salePriceEl.textContent = price;

          // Compare-at (struck-through)
          const compareEl = priceEl.querySelector('.price__sale .price-item--regular');
          if (compareEl) compareEl.textContent = compareAtPrice;
        } else {
          priceEl.classList.remove('price--on-sale');

          const regularEl = priceEl.querySelector('.price__regular .price-item--regular');
          if (regularEl) regularEl.textContent = price;
        }
      });

      // ── Fallback for non-Dawn OS 2.0 themes ───────────────────────────────
      document.querySelectorAll('[data-product-price]').forEach((el) => {
        el.textContent = price;
      });
    }
  }

  if (!customElements.get('rejuvi-oil-selector')) {
    customElements.define('rejuvi-oil-selector', RejuviOilSelector);
  }

  } catch(e) { console.error(e); }
})();
})();
